"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _context = _interopRequireDefault(require("../../components/Theme/context"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _clsx = _interopRequireDefault(require("clsx"));
var defaultStyle = require("./CircularProgress_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? defaultStyle : _props$classNames;
  var themeContext = (0, _react.useContext)(_context["default"]);
  var useStyle = themeContext.useStyle;
  if (typeof useStyle === 'function') {
    useStyle(classNames);
  }
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '22 22 44 44'
  }, props, {
    ref: ref,
    className: (0, _clsx["default"])(classNames.rotating, props.className)
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "44",
    cy: "44",
    r: "20",
    fill: "none",
    strokeWidth: "4",
    stroke: "currentColor",
    strokeDasharray: "80px,200px",
    strokeDashoffset: "0"
  }));
});